import React from "react";
import "./SuccessStories.css";
import { avatars, successStories, stats } from "./data";


const SuccessStoriesPage = () => {
  return (
    <>
      <div className="max-w-screen-xl mx-auto p-6 space-y-10 mb-7">
        {/* Header */}
        <div className="space-y-4">
          <h1
            className="text-2xl md:text-2xl font-semibold text-center md:text-right"
            style={{
              color: "#04236B",
              fontFamily: "niconne, cursive",
              // marginLeft: "72%",
              marginTop: "10px",
            }}
          >
            Tales that spark Inspiration
          </h1>
        </div>
        {/* Success Stories Container */}
        <div className="flex flex-col md:flex-row justify-between items-center bg-white space-y-4 md:space-y-0">
          {/* Left Section: Success Stories */}
          <div className="space-y-4">
            <h2 className="text-xl md:text-2xl font-medium	 text-navy-800">
              Success stories of{" "}
              <span className="text-orange-500">our learners</span>
            </h2>
            <div className="flex items-center space-x-4">
              <div className="flex -space-x-4">
                {avatars.map((item, index) => (
                  <img
                    key={index}
                    src={item.src}
                    alt={item.alt}
                    className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-white"
                  />
                ))}
              </div>
              {/* Trusted Text */}
              <span className="text-[14px]text-gray-600">
                Trusted by 7.5 Millions+ learners.
              </span>
            </div>
          </div>

          {/* Right Section: -- Stats */}
          <div className="flex flex-wrap justify-center md:justify-start space-x-6 md:space-x-8 text-center mt-5">
            {stats.map((stat, index) => (
              <div key={index} className="w-24 md:w-auto text-center">
                <div className=" text-orange-500">{stat.value}</div>
                <div className="text-[14px]text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Success Stories Cards */}
        <h3 className="text-2xl font-medium	 mb-6">
          Explore <span className="text-orange-500">Success</span> Stories
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-4">
          {successStories.map((item, index) => (
            <div
              key={index}
              className="cards relative bg-white rounded-lg border p-4 flex flex-col items-center text-center"
              style={{
                width: "100%",
                maxWidth: "330px",
                height: "300px",
                boxShadow:
                  "4px 4px 20px rgba(0, 0, 0, 0.2), -1px -1px 5px rgba(0, 0, 0, 0.1)",
                  cursor:"pointer"
              }}
            >
              {/* Profile Image */}
              <img
                src={item.userImg}
                alt={item.name}
                className="w-20 h-20 rounded-full mb-3"
              />

              {/* Name and Role */}
              <div className="font-medium	 text-lg">{item.name}</div>
              <div className="text-[14px]text-[#848383] mb-4">{item.role}</div>

              {/* Hike Percentage */}
              <div className="absolute top-2 right-2 bg-green-100 text-green-600 text-[13 px] font-medium px-3 py-1">
                {item.hike}
              </div>

              {/* Company Logo */}
              <img
                src={item.company}
                alt={item.companyName}
                className="h-10 md:h-12 mb-4 object-contain"
              />

              {/* Details */}
              <p className="text-[14px]text-gray-700">{item.details}</p>
            </div>
          ))}
        </div>
      </div>
      {/* Testimonial Section */}
      <div className="bg-gray-200 p-6 flex flex-col md:flex-row items-center space-y-6 md:space-y-0 md:space-x-6">
        <div style={{ marginLeft: "60px" }}>
          <h3 className="text-xl font-medium	 mb-2">
            Learner <span className="text-orange-500">Testimonial</span>
          </h3>
          <div className="p-6 flex space-x-6">
            <img
              src="https://s3-alpha-sig.figma.com/img/081c/343c/6dc008bf5c65e59e3be0c702ef4a219a?Expires=1738540800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=B08AaqJHRMoVUkbYcL0BkHIwwzwi3fLU~FSHM6Y1L8zSDm7P698gSyhXTzMpFhH9bPdAmyWj6clHbKNDGNqBRbJeLN-KjRysnVh-4GU1iAU95N47i23oH1kX-ra0AvQyHDmDOGWKoFayqLFFb-onFqdMnwNEqyRq3XDqQgP1q6Hf7wppYjvI~6qgZC2ND0XeD11Eb9Tk1amLsQByzVmfffUTLcOQbLOBM3KbM9yDJ4hJJpcZgPRwza3I1Dng8WQW8~3if-NvmWsxVTtMrsJHZzEDBW1bV1sIVwNlMYhLFCxQ6A3guc0wrB5l244rEXhplWYoqKVQUgJTLIQBB-hXXw__"

              alt="Testimonial"
              className="w-64 md:w-72 h-72"
            />
            <div className="space-y-4 text-center md:text-left" style={{fontSize:"40px"}}>
              <p className="text-[14px]text-gray-700">
                <span className="text-orange-500">"Mentorsity</span> has truly
                transformed my career trajectory. The online degree program
                provided by Mentorsity equipped me with the latest skills and
                knowledge necessary to excel in the IT field. Mentorsity career
                program was a Game Changer for me
                <span className="text-orange-500">"</span>.
              </p>
              <div className="space-y-5">
                <div className="font-medium	">Rajat Agarwal</div>
                <div className="text-[14px]text-gray-600">Market Analyst</div>
                <img
                  src="https://s3-alpha-sig.figma.com/img/63ad/8687/49e6c80fbad85c1b022c0459be3961fa?Expires=1738540800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=hPK6YQ9PThkSqAzcUhGGwOWyDtV82qekRZmRFjNcawSZuhwQXZOT5XXAG5kl3MvA7EqYAGNCBiJ04ChvT4dDy2-VJr0~yW95GoEnyNP8-DjF2t62erESi6Qhbz9WCzDPvTOuWfoKZBik6hPMWBw52h5V0EjlkK1K0JKOjqJscwhP~lUBeNpHKaKMH2KS~jSM5YIEJbwZbix3ctJrRUUGyZ~y5aIJt~Zbu6M7iP-EsZxeGH7GRB9aVdck3VeEGre8ateK~YZ0sXCExbF5aTHJp6Vz-7zbGGx-7qG01vyGzVGjnPMqo2nCTscilgZe9AtIZc8fjZdODXCa4w~~ztfasw__"
                  alt="Google"
                  className="h-6 text-xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessStoriesPage;
